import React from 'react';

const LineDivine = () => {
  return <div style={{ height: '1px', background: '#cccccc' }}></div>;
};

export default LineDivine;
